<template>
  <div id="main-content">
    <div class="container-fluid">
      <div class="block-header">
        <BreadCrumb />
      </div>
      <div class="row clearfix">
        <div class="col-sm-12">
          <div class="card">
            <div class="body">
              <v-chart class="chart" :option="maleCDCGrowthChart" />
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="card">
            <div class="body">
              <v-chart class="chart" :option="femaleCDCGrowthChart" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/plugins/echarts";
import BreadCrumb from "@/components/BreadCrumb.vue";
export default {
  name: "AnalyticalData",
  components: {
    BreadCrumb,
  },
  data() {
    return {
      maleCDCGrowthChart: {
        title: {
          text: "CDC Height (cm) for Age (months) Chart for Boys (2 - 20 years)",
          left: "center",
          top: "10px",
          textStyle: {
            fontSize: 16,
            color:"#004ead",
          },
        },
        tooltip: {
          trigger: "axis",
        },

        xAxis: {
          type: "category",
          data: Array.from({ length: 218 }, (_, i) => i + 24.5),
          name: "Age (months)",
          nameLocation: "middle",
          nameGap: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Height (cm)",
          min: 80,
          max: 200,
          interval: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },

        series: [
          {
            name: "3rd Percentile ",
            type: "line",
            data: [
              79.91084, 80.26037, 81.00529, 81.73416, 82.44846, 83.14945,
              83.83819, 84.51558, 85.18238, 85.83925, 86.48678, 87.12552,
              87.75597, 88.37864, 88.93297, 89.47916, 90.01766, 90.54891,
              91.07337, 91.59152, 92.10382, 92.61073, 93.11271, 93.61022,
              94.10371, 94.59361, 95.08035, 95.56435, 96.046, 96.52568,
              97.00376, 97.48058, 97.95648, 98.43175, 98.90667, 99.38151,
              99.8565, 100.3318, 100.8077, 101.2843, 101.7618, 102.2401,
              102.7195, 103.2, 103.6815, 104.1642, 104.6479, 105.1326, 105.6183,
              106.1048, 106.5921, 107.0799, 107.5682, 108.0566, 108.5451,
              109.0335, 109.5214, 110.0086, 110.495, 110.9801, 111.4638,
              111.9459, 112.4259, 112.9036, 113.3789, 113.8513, 114.3206,
              114.7867, 115.2491, 115.7077, 116.1623, 116.6127, 117.0587, 117.5,
              117.9366, 118.3683, 118.7949, 119.2165, 119.633, 120.0442,
              120.4502, 120.851, 121.2467, 121.6372, 122.0228, 122.4034,
              122.7793, 123.1506, 123.5175, 123.8803, 124.2391, 124.5943,
              124.9462, 125.295, 125.6413, 125.9852, 126.3272, 126.6678,
              127.0073, 127.3462, 127.6851, 128.0243, 128.3643, 128.7058,
              129.0491, 129.3949, 129.7436, 130.0958, 130.452, 130.8127,
              131.1785, 131.5498, 131.9272, 132.311, 132.7018, 133.1, 133.5059,
              133.9199, 134.3423, 134.7733, 135.2132, 135.6621, 136.1202,
              136.5875, 137.064, 137.5496, 138.0442, 138.5477, 139.0597,
              139.5799, 140.108, 140.6435, 141.1858, 141.7345, 142.2889,
              142.8482, 143.4118, 143.9788, 144.5483, 145.1196, 145.6915,
              146.2633, 146.8339, 147.4023, 147.9674, 148.5284, 149.0842,
              149.6338, 150.1763, 150.7107, 151.2363, 151.7521, 152.2575,
              152.7517, 153.2342, 153.7043, 154.1615, 154.6056, 155.036,
              155.4526, 155.8552, 156.2436, 156.6178, 156.9777, 157.3235,
              157.6551, 157.9729, 158.277, 158.5676, 158.845, 159.1095,
              159.3614, 159.6011, 159.829, 160.0455, 160.2508, 160.4456, 160.63,
              160.8046, 160.9697, 161.1258, 161.2733, 161.4125, 161.5438,
              161.6676, 161.7843, 161.8942, 161.9977, 162.0951, 162.1866,
              162.2727, 162.3537, 162.4297, 162.5011, 162.5681, 162.631, 162.69,
              162.7453, 162.7972, 162.8458, 162.8914, 162.9341, 162.9741,
              163.0115, 163.0465, 163.0793, 163.11, 163.1387, 163.1656,
              163.1907, 163.2142, 163.2361, 163.2566, 163.2757, 163.2936,
              163.3103, 163.3259, 163.3333,
            ],

            endLabel: {
              show: true,
              formatter: "3rd",
            },
            emphasis: {
              focus: "series",
            },
            smooth: true,
            lineStyle: {
              color: "#b9b0b0",
            },
            showSymbol: false,
          },
          {
            name: "5th Percentile ",
            type: "line",
            data: [
              80.72977, 81.08868, 81.83445, 82.56406, 83.27899, 83.98045,
              84.66948, 85.34694, 86.01357, 86.66999, 87.3168, 87.95452,
              88.58366, 89.20473, 89.77301, 90.33306, 90.88532, 91.43025,
              91.96832, 92.49999, 93.0257, 93.54592, 94.06109, 94.57166,
              95.07806, 95.5807, 96.08, 96.57635, 97.07013, 97.5617, 98.05141,
              98.53958, 99.02654, 99.51256, 99.99791, 100.4828, 100.9676,
              101.4523, 101.9372, 102.4225, 102.9082, 103.3945, 103.8814,
              104.369, 104.8574, 105.3466, 105.8364, 106.327, 106.8182,
              107.3099, 107.8021, 108.2946, 108.7873, 109.2801, 109.7727,
              110.2649, 110.7566, 111.2476, 111.7375, 112.2263, 112.7135,
              113.1991, 113.6827, 114.1642, 114.6431, 115.1194, 115.5927,
              116.0629, 116.5297, 116.9928, 117.4521, 117.9074, 118.3585,
              118.8053, 119.2475, 119.6851, 120.1179, 120.5459, 120.969,
              121.3872, 121.8004, 122.2086, 122.6119, 123.0103, 123.4039,
              123.7928, 124.1771, 124.5569, 124.9325, 125.304, 125.6717,
              126.0358, 126.3966, 126.7544, 127.1096, 127.4624, 127.8132,
              128.1625, 128.5106, 128.8579, 129.2051, 129.5524, 129.9004,
              130.2496, 130.6005, 130.9536, 131.3094, 131.6686, 132.0316,
              132.399, 132.7714, 133.1491, 133.5329, 133.9232, 134.3205,
              134.7252, 135.1378, 135.5588, 135.9885, 136.4271, 136.8751,
              137.3326, 137.7998, 138.2769, 138.7638, 139.2605, 139.767,
              140.2831, 140.8085, 141.3429, 141.8859, 142.4369, 142.9955,
              143.5608, 144.1322, 144.7089, 145.29, 145.8746, 146.4615,
              147.0498, 147.6385, 148.2262, 148.812, 149.3947, 149.9731,
              150.5461, 151.1127, 151.6717, 152.2221, 152.763, 153.2935,
              153.8127, 154.32, 154.8147, 155.2961, 155.7638, 156.2174,
              156.6566, 157.0811, 157.4907, 157.8853, 158.265, 158.6298,
              158.9798, 159.315, 159.6359, 159.9425, 160.2352, 160.5143,
              160.7802, 161.0332, 161.2738, 161.5023, 161.7191, 161.9247,
              162.1196, 162.3041, 162.4786, 162.6437, 162.7997, 162.947,
              163.086, 163.2172, 163.3409, 163.4575, 163.5673, 163.6708,
              163.7682, 163.8598, 163.9461, 164.0272, 164.1034, 164.1751,
              164.2424, 164.3057, 164.3651, 164.4209, 164.4733, 164.5224,
              164.5686, 164.6119, 164.6526, 164.6907, 164.7265, 164.76,
              164.7915, 164.821, 164.8487, 164.8746, 164.8989, 164.9217,
              164.9431, 164.9631, 164.9819, 164.9995, 165.016, 165.0315,
              165.0389,
            ],

            endLabel: {
              show: true,
              formatter: "5th",
            },
            smooth: true,
            lineStyle: {
              color: "#999090",
            },
            showSymbol: false,
          },
          {
            name: "10th Percentile ",
            type: "line",
            data: [
              81.99171, 82.36401, 83.11387, 83.84716, 84.56534, 85.26962,
              85.96098, 86.64027, 87.3082, 87.9654, 88.61244, 89.24986,
              89.87816, 90.49789, 91.08608, 91.66589, 92.23779, 92.80225,
              93.35972, 93.91068, 94.45556, 94.99482, 95.52888, 96.05817,
              96.5831, 97.10407, 97.62147, 98.13566, 98.64701, 99.15585,
              99.6625, 100.1673, 100.6705, 101.1723, 101.6731, 102.173,
              102.6723, 103.1712, 103.6697, 104.1682, 104.6666, 105.1651,
              105.6638, 106.1627, 106.6619, 107.1614, 107.6611, 108.1612,
              108.6614, 109.1619, 109.6624, 110.1629, 110.6633, 111.1634,
              111.6631, 112.1623, 112.6608, 113.1583, 113.6548, 114.1499,
              114.6436, 115.1356, 115.6257, 116.1136, 116.5992, 117.0822,
              117.5625, 118.0398, 118.5139, 118.9847, 119.4519, 119.9153,
              120.3749, 120.8305, 121.2819, 121.729, 122.1716, 122.6099,
              123.0435, 123.4726, 123.897, 124.3168, 124.7319, 125.1425,
              125.5485, 125.9501, 126.3473, 126.7402, 127.1291, 127.514,
              127.8953, 128.273, 128.6474, 129.0189, 129.3876, 129.754,
              130.1183, 130.4809, 130.8422, 131.2026, 131.5625, 131.9224,
              132.2828, 132.6441, 133.0068, 133.3714, 133.7386, 134.1089,
              134.4828, 134.8608, 135.2437, 135.6318, 136.026, 136.4266,
              136.8343, 137.2496, 137.673, 138.105, 138.5461, 138.9968,
              139.4573, 139.928, 140.4091, 140.9009, 141.4034, 141.9167,
              142.4407, 142.9752, 143.52, 144.0746, 144.6388, 145.2117,
              145.7928, 146.3813, 146.9763, 147.5767, 148.1815, 148.7896,
              149.3998, 150.0107, 150.621, 151.2295, 151.8348, 152.4355,
              153.0304, 153.6181, 154.1975, 154.7674, 155.3268, 155.8746,
              156.4099, 156.9319, 157.4399, 157.9334, 158.4118, 158.8747,
              159.3218, 159.7529, 160.168, 160.5669, 160.9498, 161.3167,
              161.6679, 162.0035, 162.3239, 162.6294, 162.9204, 163.1973,
              163.4605, 163.7104, 163.9476, 164.1725, 164.3856, 164.5873,
              164.7782, 164.9587, 165.1292, 165.2903, 165.4424, 165.586,
              165.7214, 165.8491, 165.9694, 166.0828, 166.1897, 166.2903,
              166.3851, 166.4743, 166.5583, 166.6373, 166.7116, 166.7816,
              166.8474, 166.9094, 166.9676, 167.0224, 167.074, 167.1224,
              167.168, 167.2109, 167.2513, 167.2892, 167.325, 167.3585,
              167.3902, 167.4199, 167.4479, 167.4742, 167.499, 167.5224,
              167.5444, 167.5651, 167.5846, 167.6029, 167.6203, 167.6366,
              167.6519, 167.6593,
            ],
            endLabel: {
              show: true,
              formatter: "10th",
            },
            smooth: true,
            lineStyle: {
              color: "#716868",
            },
            showSymbol: false,
          },
          {
            name: "25th Percentile ",
            type: "line",
            data: [
              84.10289, 84.49471, 85.25888, 86.00517, 86.73507, 87.44977,
              88.15028, 88.83745, 89.51202, 90.17464, 90.82592, 91.46645,
              92.0968, 92.71756, 93.3344, 93.94268, 94.54291, 95.13557,
              95.72115, 96.30009, 96.87286, 97.43989, 98.00159, 98.55838,
              99.11064, 99.65875, 100.2031, 100.7439, 101.2817, 101.8166,
              102.3491, 102.8792, 103.4074, 103.9339, 104.4588, 104.9825,
              105.505, 106.0265, 106.5472, 107.0673, 107.5868, 108.1058,
              108.6244, 109.1427, 109.6607, 110.1785, 110.696, 111.2132,
              111.7302, 112.2469, 112.7631, 113.2789, 113.7942, 114.3089,
              114.8229, 115.336, 115.8481, 116.3592, 116.869, 117.3774,
              117.8842, 118.3893, 118.8926, 119.3938, 119.8927, 120.3893,
              120.8833, 121.3746, 121.863, 122.3483, 122.8305, 123.3092,
              123.7845, 124.2562, 124.7242, 125.1882, 125.6484, 126.1045,
              126.5565, 127.0044, 127.4481, 127.8876, 128.3228, 128.7539,
              129.1807, 129.6035, 130.0222, 130.4369, 130.8477, 131.2548,
              131.6584, 132.0585, 132.4555, 132.8495, 133.2407, 133.6295,
              134.0161, 134.4008, 134.7841, 135.1663, 135.5477, 135.9288,
              136.3101, 136.692, 137.075, 137.4597, 137.8466, 138.2362,
              138.6292, 139.0262, 139.4278, 139.8346, 140.2472, 140.6664,
              141.0928, 141.5269, 141.9694, 142.4209, 142.882, 143.3532,
              143.835, 144.3277, 144.8317, 145.3473, 145.8746, 146.4137,
              146.9645, 147.5269, 148.1005, 148.6849, 149.2795, 149.8836,
              150.4962, 151.1165, 151.7433, 152.3754, 153.0113, 153.6498,
              154.2892, 154.928, 155.5647, 156.1977, 156.8253, 157.4462,
              158.0587, 158.6615, 159.2532, 159.8327, 160.3988, 160.9506,
              161.4872, 162.0078, 162.5118, 162.9988, 163.4685, 163.9205,
              164.3547, 164.7713, 165.1701, 165.5514, 165.9154, 166.2625,
              166.5929, 166.9072, 167.2057, 167.489, 167.7576, 168.012,
              168.2528, 168.4805, 168.6958, 168.8991, 169.0911, 169.2722,
              169.4431, 169.6041, 169.756, 169.8991, 170.0339, 170.1608,
              170.2804, 170.3931, 170.4991, 170.599, 170.693, 170.7816, 170.865,
              170.9436, 171.0176, 171.0873, 171.1529, 171.2148, 171.2732,
              171.3282, 171.3801, 171.429, 171.4752, 171.5188, 171.5599,
              171.5988, 171.6355, 171.6701, 171.7029, 171.7339, 171.7632,
              171.791, 171.8172, 171.8421, 171.8657, 171.888, 171.9091,
              171.9292, 171.9483, 171.9663, 171.9835, 171.9998, 172.0153,
              172.0227,
            ],
            endLabel: {
              show: true,
              formatter: "25th",
            },
            smooth: true,
            lineStyle: {
              color: "#5d5555",
            },
            showSymbol: false,
          },
          {
            name: "50th Percentile ",
            type: "line",
            data: [
              86.4522, 86.86161, 87.65247, 88.42326, 89.17549, 89.91041,
              90.62908, 91.33242, 92.02127, 92.69638, 93.35847, 94.00823,
              94.64637, 95.27359, 95.91475, 96.54734, 97.17191, 97.78898,
              98.39903, 99.00254, 99.59998, 100.1918, 100.7783, 101.36,
              101.9373, 102.5105, 103.0799, 103.6459, 104.2087, 104.7687,
              105.3262, 105.8813, 106.4343, 106.9855, 107.535, 108.083,
              108.6296, 109.1751, 109.7196, 110.2631, 110.8058, 111.3477,
              111.889, 112.4296, 112.9696, 113.509, 114.0479, 114.5861,
              115.1238, 115.6609, 116.1973, 116.7329, 117.2678, 117.8018,
              118.3348, 118.8668, 119.3977, 119.9272, 120.4554, 120.9821,
              121.5072, 122.0305, 122.552, 123.0714, 123.5886, 124.1035,
              124.616, 125.1259, 125.6331, 126.1374, 126.6388, 127.137, 127.632,
              128.1237, 128.6119, 129.0966, 129.5777, 130.055, 130.5286,
              130.9983, 131.4641, 131.926, 132.384, 132.8381, 133.2882,
              133.7345, 134.1769, 134.6155, 135.0504, 135.4818, 135.9097,
              136.3343, 136.7557, 137.1742, 137.5899, 138.0032, 138.4143,
              138.8234, 139.231, 139.6373, 140.0427, 140.4477, 140.8527,
              141.2582, 141.6646, 142.0725, 142.4824, 142.8949, 143.3107,
              143.7304, 144.1545, 144.5838, 145.019, 145.4607, 145.9097,
              146.3665, 146.832, 147.3066, 147.7911, 148.2859, 148.7917,
              149.3088, 149.8376, 150.3784, 150.9313, 151.4964, 152.0735,
              152.6624, 153.2627, 153.8738, 154.4951, 155.1255, 155.7642,
              156.4099, 157.0612, 157.7168, 158.3751, 159.0344, 159.6931,
              160.3493, 161.0015, 161.6478, 162.2865, 162.9161, 163.535,
              164.1418, 164.7352, 165.314, 165.8771, 166.4236, 166.9528,
              167.4641, 167.9571, 168.4313, 168.8867, 169.3231, 169.7405,
              170.1393, 170.5195, 170.8815, 171.2257, 171.5525, 171.8626,
              172.1563, 172.4343, 172.6972, 172.9456, 173.1801, 173.4014,
              173.6101, 173.8067, 173.992, 174.1665, 174.3308, 174.4854,
              174.631, 174.768, 174.8969, 175.0182, 175.1323, 175.2398, 175.341,
              175.4362, 175.5259, 175.6104, 175.6901, 175.7652, 175.836,
              175.9028, 175.9658, 176.0254, 176.0816, 176.1348, 176.185,
              176.2326, 176.2776, 176.3202, 176.3606, 176.3989, 176.4352,
              176.4697, 176.5024, 176.5335, 176.563, 176.5911, 176.6179,
              176.6433, 176.6676, 176.6907, 176.7127, 176.7337, 176.7538,
              176.773, 176.7913, 176.8088, 176.8255, 176.8415, 176.8492,
            ],
            endLabel: {
              show: true,
              formatter: "50th",
            },
            smooth: true,
            lineStyle: {
              color: "#000000",
            },
            showSymbol: false,
          },
          {
            name: "75th Percentile ",
            type: "line",
            data: [
              88.80525, 89.22805, 90.05675, 90.8626, 91.64711, 92.41159,
              93.15719, 93.88496, 94.59585, 95.2908, 95.97068, 96.63637,
              97.28875, 97.9287, 98.58525, 99.23358, 99.87426, 100.5078,
              101.1348, 101.7556, 102.3708, 102.9807, 103.5858, 104.1865,
              104.7831, 105.3759, 105.9654, 106.5518, 107.1354, 107.7165,
              108.2953, 108.872, 109.4469, 110.0201, 110.5919, 111.1623,
              111.7316, 112.2998, 112.8671, 113.4335, 113.9992, 114.5641,
              115.1284, 115.6921, 116.2551, 116.8176, 117.3794, 117.9407,
              118.5012, 119.0611, 119.6203, 120.1786, 120.7361, 121.2926,
              121.848, 122.4024, 122.9555, 123.5073, 124.0576, 124.6064,
              125.1535, 125.6987, 126.2421, 126.7834, 127.3225, 127.8594,
              128.3937, 128.9256, 129.4547, 129.981, 130.5044, 131.0247,
              131.5419, 132.0559, 132.5664, 133.0736, 133.5771, 134.0771,
              134.5734, 135.066, 135.5548, 136.0397, 136.5209, 136.9982,
              137.4717, 137.9414, 138.4073, 138.8696, 139.3282, 139.7833,
              140.235, 140.6835, 141.1289, 141.5713, 142.0111, 142.4484,
              142.8835, 143.3168, 143.7484, 144.1789, 144.6085, 145.0377,
              145.4669, 145.8965, 146.3272, 146.7593, 147.1936, 147.6305,
              148.0707, 148.5147, 148.9633, 149.4172, 149.8769, 150.3433,
              150.8169, 151.2984, 151.7885, 152.2878, 152.7969, 153.3164,
              153.8466, 154.3881, 154.941, 155.5056, 156.0819, 156.6699,
              157.2694, 157.88, 158.5012, 159.1324, 159.7725, 160.4207,
              161.0758, 161.7364, 162.401, 163.0682, 163.7363, 164.4035,
              165.0681, 165.7283, 166.3823, 167.0284, 167.665, 168.2905,
              168.9033, 169.5022, 170.0859, 170.6535, 171.2039, 171.7364,
              172.2504, 172.7455, 173.2213, 173.6778, 174.1148, 174.5324,
              174.9309, 175.3105, 175.6716, 176.0146, 176.34, 176.6483,
              176.9402, 177.2163, 177.4771, 177.7234, 177.9558, 178.175,
              178.3815, 178.5762, 178.7595, 178.9321, 179.0946, 179.2476,
              179.3915, 179.5271, 179.6547, 179.7748, 179.888, 179.9946,
              180.095, 180.1896, 180.2789, 180.3631, 180.4426, 180.5176,
              180.5885, 180.6555, 180.7189, 180.7789, 180.8357, 180.8895,
              180.9405, 180.9889, 181.0348, 181.0784, 181.1199, 181.1593,
              181.1968, 181.2325, 181.2666, 181.299, 181.33, 181.3595, 181.3877,
              181.4147, 181.4405, 181.4651, 181.4887, 181.5113, 181.533,
              181.5538, 181.5737, 181.5928, 181.6111, 181.6287, 181.6456,
              181.6538,
            ],
            endLabel: {
              show: true,
              formatter: "75th",
            },
            smooth: true,
            lineStyle: {
              color: "#5d5555",
            },
            showSymbol: false,
          },
          {
            name: "90th Percentile ",
            type: "line",
            data: [
              90.92619, 91.35753, 92.22966, 93.07608, 93.89827, 94.69757,
              95.47522, 96.23239, 96.97022, 97.68978, 98.39218, 99.07848,
              99.74979, 100.4072, 101.069, 101.7234, 102.3709, 103.012,
              103.6473, 104.2771, 104.9021, 105.5225, 106.1387, 106.7513,
              107.3604, 107.9665, 108.5698, 109.1706, 109.7693, 110.366,
              110.9609, 111.5543, 112.1464, 112.7374, 113.3273, 113.9164,
              114.5047, 115.0924, 115.6795, 116.2661, 116.8522, 117.438,
              118.0234, 118.6084, 119.1931, 119.7774, 120.3613, 120.9447,
              121.5277, 122.1101, 122.6918, 123.2729, 123.8532, 124.4327,
              125.0111, 125.5884, 126.1646, 126.7394, 127.3128, 127.8846,
              128.4547, 129.023, 129.5893, 130.1535, 130.7154, 131.275,
              131.8321, 132.3865, 132.9381, 133.4868, 134.0325, 134.5751,
              135.1144, 135.6504, 136.1829, 136.7118, 137.2371, 137.7587,
              138.2765, 138.7905, 139.3006, 139.8069, 140.3093, 140.8077,
              141.3023, 141.793, 142.28, 142.7632, 143.2428, 143.7188, 144.1915,
              144.661, 145.1273, 145.5909, 146.0518, 146.5103, 146.9668,
              147.4214, 147.8747, 148.3268, 148.7782, 149.2294, 149.6808,
              150.1329, 150.5861, 151.041, 151.4982, 151.9583, 152.4218,
              152.8894, 153.3617, 153.8394, 154.323, 154.8133, 155.3109,
              155.8164, 156.3303, 156.8532, 157.3857, 157.928, 158.4807,
              159.0439, 159.6179, 160.2026, 160.7981, 161.4041, 162.0203,
              162.6462, 163.2811, 163.9243, 164.5748, 165.2314, 165.893,
              166.5581, 167.2253, 167.8929, 168.5594, 169.2231, 169.8822,
              170.535, 171.1798, 171.8151, 172.4393, 173.0509, 173.6486,
              174.2313, 174.7978, 175.3473, 175.879, 176.3923, 176.8868,
              177.3622, 177.8183, 178.2551, 178.6727, 179.0712, 179.451,
              179.8124, 180.1559, 180.482, 180.7912, 181.0841, 181.3614,
              181.6236, 181.8715, 182.1056, 182.3267, 182.5353, 182.7322,
              182.9179, 183.0931, 183.2583, 183.414, 183.5609, 183.6995,
              183.8302, 183.9535, 184.0699, 184.1797, 184.2835, 184.3815,
              184.4741, 184.5617, 184.6446, 184.723, 184.7972, 184.8676,
              184.9343, 184.9975, 185.0576, 185.1146, 185.1687, 185.2202,
              185.2692, 185.3159, 185.3603, 185.4026, 185.443, 185.4815,
              185.5182, 185.5534, 185.5869, 185.619, 185.6497, 185.6791,
              185.7073, 185.7343, 185.7601, 185.7849, 185.8087, 185.8316,
              185.8535, 185.8746, 185.8949, 185.9144, 185.9331, 185.9512,
              185.9599,
            ],
            endLabel: {
              show: true,
              formatter: "90th",
            },
            smooth: true,
            lineStyle: {
              color: "#716868",
            },
            showSymbol: false,
          },
          {
            name: "95th Percentile ",
            type: "line",
            data: [
              92.19688, 92.63177, 93.53407, 94.40885, 95.25754, 96.08149,
              96.88198, 97.66027, 98.41758, 99.15514, 99.87416, 100.5759,
              101.2615, 101.9324, 102.593, 103.247, 103.8948, 104.537, 105.1739,
              105.8061, 106.434, 107.0579, 107.6784, 108.2956, 108.9101,
              109.522, 110.1317, 110.7394, 111.3454, 111.95, 112.5533, 113.1555,
              113.7568, 114.3574, 114.9575, 115.557, 116.1561, 116.755,
              117.3536, 117.9521, 118.5505, 119.1487, 119.7469, 120.345,
              120.943, 121.5408, 122.1384, 122.7359, 123.333, 123.9297, 124.526,
              125.1217, 125.7168, 126.3111, 126.9045, 127.4969, 128.0882,
              128.6782, 129.2668, 129.8538, 130.4392, 131.0226, 131.6041,
              132.1834, 132.7605, 133.335, 133.907, 134.4763, 135.0426, 135.606,
              136.1662, 136.7231, 137.2767, 137.8267, 138.3731, 138.9159,
              139.4548, 139.9899, 140.5211, 141.0484, 141.5716, 142.0908,
              142.6061, 143.1173, 143.6245, 144.1278, 144.6272, 145.1228,
              145.6148, 146.1032, 146.5882, 147.0699, 147.5486, 148.0245,
              148.4979, 148.9689, 149.438, 149.9053, 150.3714, 150.8365,
              151.301, 151.7655, 152.2303, 152.696, 153.1631, 153.6321,
              154.1035, 154.578, 155.0562, 155.5386, 156.0258, 156.5186,
              157.0174, 157.5229, 158.0356, 158.5562, 159.0851, 159.6228,
              160.1697, 160.7262, 161.2924, 161.8686, 162.4549, 163.0511,
              163.6571, 164.2726, 164.8972, 165.5302, 166.1711, 166.8187,
              167.4723, 168.1305, 168.7923, 169.4561, 170.1205, 170.784,
              171.445, 172.1018, 172.7528, 173.3965, 174.0312, 174.6554,
              175.2677, 175.8668, 176.4515, 177.0206, 177.5733, 178.1088,
              178.6264, 179.1256, 179.6061, 180.0676, 180.5102, 180.9338,
              181.3385, 181.7247, 182.0927, 182.4429, 182.7757, 183.0918,
              183.3916, 183.6757, 183.9449, 184.1997, 184.4408, 184.6687,
              184.8843, 185.0879, 185.2804, 185.4623, 185.6341, 185.7965,
              185.9498, 186.0948, 186.2318, 186.3613, 186.4837, 186.5995,
              186.7091, 186.8128, 186.911, 187.004, 187.0922, 187.1757, 187.255,
              187.3302, 187.4016, 187.4694, 187.5338, 187.5951, 187.6534,
              187.7088, 187.7617, 187.812, 187.86, 187.9057, 187.9494, 187.9911,
              188.0309, 188.069, 188.1054, 188.1402, 188.1736, 188.2055,
              188.236, 188.2653, 188.2934, 188.3204, 188.3462, 188.3711,
              188.3949, 188.4178, 188.4399, 188.461, 188.4814, 188.501,
              188.5198, 188.529,
            ],
            endLabel: {
              show: true,
              formatter: "95th",
            },
            smooth: true,
            lineStyle: {
              color: "#999090",
            },
            showSymbol: false,
          },
          {
            name: "97th Percentile ",
            type: "line",
            data: [
              93.02265, 93.45923, 94.38278, 95.27762, 96.14512, 96.98663,
              97.80345, 98.59691, 99.36828, 100.1189, 100.8501, 101.5631,
              102.2593, 102.9402, 103.5983, 104.2503, 104.8967, 105.538,
              106.1747, 106.8071, 107.4357, 108.0609, 108.683, 109.3024,
              109.9193, 110.5342, 111.1473, 111.7588, 112.369, 112.9781,
              113.5863, 114.1937, 114.8006, 115.4072, 116.0134, 116.6194,
              117.2254, 117.8314, 118.4374, 119.0435, 119.6498, 120.2562,
              120.8627, 121.4694, 122.0761, 122.6829, 123.2897, 123.8965,
              124.5031, 125.1095, 125.7156, 126.3212, 126.9263, 127.5307,
              128.1344, 128.7371, 129.3387, 129.9391, 130.5381, 131.1356,
              131.7314, 132.3253, 132.9172, 133.507, 134.0943, 134.6792,
              135.2615, 135.8409, 136.4173, 136.9906, 137.5607, 138.1274,
              138.6906, 139.2502, 139.806, 140.358, 140.9062, 141.4503,
              141.9904, 142.5263, 143.0582, 143.586, 144.1096, 144.6291,
              145.1445, 145.656, 146.1634, 146.6671, 147.167, 147.6633,
              148.1562, 148.6459, 149.1325, 149.6163, 150.0977, 150.5767,
              151.0539, 151.5294, 152.0038, 152.4773, 152.9504, 153.4235,
              153.8972, 154.3718, 154.848, 155.3263, 155.8072, 156.2913,
              156.7792, 157.2715, 157.7688, 158.2717, 158.7806, 159.2964,
              159.8193, 160.35, 160.889, 161.4365, 161.993, 162.5588, 163.1339,
              163.7185, 164.3126, 164.916, 165.5285, 166.1497, 166.7791,
              167.416, 168.0596, 168.7091, 169.3634, 170.0213, 170.6817,
              171.343, 172.004, 172.663, 173.3186, 173.9691, 174.6131, 175.249,
              175.8753, 176.4906, 177.0935, 177.6829, 178.2575, 178.8165,
              179.3589, 179.884, 180.3913, 180.8804, 181.3509, 181.8027,
              182.2358, 182.6503, 183.0463, 183.4242, 183.7842, 184.127,
              184.4528, 184.7624, 185.0562, 185.3349, 185.599, 185.8493,
              186.0863, 186.3107, 186.5231, 186.724, 186.9142, 187.0941,
              187.2643, 187.4254, 187.5779, 187.7222, 187.8588, 187.9881,
              188.1106, 188.2267, 188.3368, 188.4411, 188.54, 188.6338,
              188.7229, 188.8075, 188.8878, 188.9642, 189.0368, 189.1058,
              189.1715, 189.234, 189.2936, 189.3503, 189.4044, 189.456,
              189.5052, 189.5522, 189.5971, 189.6399, 189.6809, 189.7201,
              189.7575, 189.7934, 189.8277, 189.8606, 189.8922, 189.9224,
              189.9513, 189.9791, 190.0058, 190.0314, 190.056, 190.0797,
              190.1024, 190.1242, 190.1452, 190.1654, 190.1849, 190.1943,
            ],
            endLabel: {
              show: true,
              formatter: "97th",
            },
            smooth: true,
            lineStyle: {
              color: "#b9b0b0",
            },
            showSymbol: false,
          },
        ],
      },

      femaleCDCGrowthChart: {
        title: {
          text: "CDC Height (cm) for Age (months) Chart for Girls (2 - 20 years)",
          left: "center",
          top: "10px",
          textStyle: {
            fontSize: 16,
            color:"#004ead",
          },
        },
        tooltip: {
          trigger: "axis",
        },

        xAxis: {
          type: "category",
          data: Array.from({ length: 218 }, (_, i) => i + 24.5),
          name: "Age (months)",
          nameLocation: "middle",
          nameGap: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Height (cm)",
          min: 80,
          max: 200,
          interval: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },

        series: [
          {
            name: "3rd Percentile ",
            type: "line",
            data: [
              78.43754166, 78.82133263, 79.60197647, 80.37554759, 81.1356973,
              81.87746051, 82.59711819, 83.29206184, 83.96065415, 84.60209562,
              85.21630353, 85.80378996, 86.36557262, 86.90307328, 87.43482018,
              87.95945137, 88.47849954, 88.99330218, 89.50502066, 90.01465759,
              90.52307278, 91.03099757, 91.5390479, 92.04773605, 92.55748123,
              93.06861913, 93.58141046, 94.09604867, 94.61266684, 95.13134395,
              95.65211042, 96.17495324, 96.69982047, 97.2266254, 97.75525036,
              98.28555005, 98.81735475, 99.35047319, 99.88469514, 100.4197939,
              100.9555286, 101.4916463, 102.0278838, 102.5639698, 103.0996264,
              103.6345709, 104.1685175, 104.7011761, 105.2322625, 105.7614857,
              106.2885612, 106.8132066, 107.3351443, 107.8541019, 108.3698135,
              108.8820206, 109.3904733, 109.8949308, 110.3951624, 110.890948,
              111.3820796, 111.868361, 112.3496093, 112.825655, 113.2963432,
              113.7615336, 114.2211014, 114.674938, 115.1229513, 115.5650666,
              116.001227, 116.4313942, 116.8555488, 117.2736916, 117.6858437,
              118.092048, 118.4923693, 118.8868959, 119.2757403, 119.6590402,
              120.0369603, 120.4096928, 120.7774598, 121.140514, 121.4991408,
              121.8536605, 122.2044292, 122.551842, 122.8963342, 123.2383839,
              123.5785142, 123.9172948, 124.2553446, 124.5933332, 124.9319822,
              125.2720662, 125.6144133, 125.9599043, 126.3094709, 126.6640931,
              127.0247941, 127.3926332, 127.7686986, 128.1540923, 128.5499184,
              128.9572634, 129.3771753, 129.8106385, 130.2585454, 130.7216652,
              131.2006102, 131.6958014, 132.2074327, 132.7354383, 133.2794613,
              133.8388331, 134.4125492, 134.9992687, 135.5973139, 136.2046931,
              136.8191174, 137.4380555, 138.0587804, 138.6784334, 139.2940935,
              139.902849, 140.5018697, 141.0884738, 141.6601883, 142.2147984,
              142.7503859, 143.2653544, 143.7584411, 144.2287179, 144.6755805,
              145.0987292, 145.4981426, 145.8740473, 146.2268836, 146.5572714,
              146.8659759, 147.1538752, 147.4219304, 147.6711585, 147.902609,
              148.1173446, 148.3164186, 148.5008727, 148.6717163, 148.8299213,
              148.976416, 149.1120814, 149.2377485, 149.3541954, 149.4621532,
              149.5622993, 149.6552628, 149.7416255, 149.8219242, 149.8966533,
              149.9662668, 150.0311812, 150.0917784, 150.1484074, 150.2013879,
              150.2510113, 150.2975443, 150.3412298, 150.3822898, 150.4209266,
              150.4573249, 150.4916531, 150.524065, 150.5547008, 150.5836887,
              150.6111457, 150.6371789, 150.661886, 150.6853568, 150.7076733,
              150.7289106, 150.749138, 150.7684187, 150.7868111, 150.8043689,
              150.8211416, 150.8371748, 150.8525106, 150.8671882, 150.8812435,
              150.8947102, 150.9076191, 150.9199994, 150.9318778, 150.9432795,
              150.9542279, 150.9647448, 150.9748507, 150.9845649, 150.9939053,
              151.0028889, 151.0115315, 151.0198482, 151.0278532, 151.0355596,
              151.0429803, 151.0501271, 151.0570114, 151.0636438, 151.0700346,
              151.0761934, 151.0821295, 151.0878515, 151.0933679, 151.0986866,
              151.1038152, 151.1087609, 151.1111674,
            ],

            endLabel: {
              show: true,
              formatter: "3rd",
            },
            smooth: true,
            lineStyle: {
              color: "#999090",
            },
            showSymbol: false,
          },
          {
            name: "5th Percentile ",
            type: "line",
            data: [
              79.25981989, 79.64776859, 80.44225735, 81.22666181, 81.99539596,
              82.74410888, 83.46956585, 84.16952943, 84.84263937, 85.48829708,
              86.10655881, 86.69803144, 87.26378819, 87.80528157, 88.34236213,
              88.87255864, 89.39733426, 89.91797078, 90.43558554, 90.95114701,
              91.4654891, 91.97932415, 92.49325483, 93.00778484, 93.52332863,
              94.04022021, 94.55872109, 95.07902737, 95.60127628, 96.12555202,
              96.65189097, 97.18028656, 97.7106936, 98.24303219, 98.77719141,
              99.31303257, 99.85039229, 100.3890853, 100.9289069, 101.4696357,
              102.0110354, 102.5528574, 103.0948423, 103.6367221, 104.1782217,
              104.7190606, 105.258955, 105.797617, 106.3347618, 106.8701003,
              107.4033481, 107.9342229, 108.4624465, 108.987746, 109.5098548,
              110.0285133, 110.5434704, 111.0544841, 111.5613221, 112.0637632,
              112.5615976, 113.054628, 113.54267, 114.0255532, 114.5031216,
              114.9752341, 115.4417656, 115.9026074, 116.3576679, 116.8068731,
              117.2501678, 117.6875155, 118.1188998, 118.5443251, 118.9638171,
              119.3774239, 119.7852171, 120.1872927, 120.5837721, 120.9748035,
              121.3605632, 121.7412571, 122.1171219, 122.4884272, 122.8554769,
              123.2186111, 123.5782083, 123.9346869, 124.2885075, 124.6401749,
              124.9902397, 125.3393004, 125.6880049, 126.0370512, 126.3871885,
              126.7392174, 127.0939883, 127.4524005, 127.8153983, 128.1839668,
              128.5591249, 128.9419168, 129.3334014, 129.7346372, 130.1466666,
              130.5704957, 131.0070717, 131.4572565, 131.9217986, 132.4013028,
              132.8961979, 133.4067049, 133.9328066, 134.4742195, 135.0303699,
              135.6003795, 136.1830524, 136.7768804, 137.3800519, 137.9904798,
              138.6058289, 139.2235689, 139.8410247, 140.4554388, 141.064036,
              141.6640898, 142.2529855, 142.8282787, 143.3877452, 143.9294218,
              144.4516354, 144.9530205, 145.4325259, 145.8894106, 146.3232308,
              146.7338197, 147.1212613, 147.4858611, 147.8281145, 148.148675,
              148.4483225, 148.7279342, 148.9884574, 149.2308852, 149.4562355,
              149.6655332, 149.8597926, 150.0400107, 150.2071532, 150.3621482,
              150.5058813, 150.6391923, 150.7628729, 150.877665, 150.9842639,
              151.0833153, 151.1754186, 151.2611287, 151.3409575, 151.415377,
              151.4848208, 151.5496874, 151.610342, 151.6671193, 151.7203255,
              151.7702407, 151.8171212, 151.8612008, 151.9026934, 151.9417942,
              151.9786817, 152.013519, 152.0464549, 152.0776257, 152.1071558,
              152.1351593, 152.1617405, 152.1869949, 152.2110102, 152.2338667,
              152.2556383, 152.2763929, 152.296193, 152.3150959, 152.3331548,
              152.3504187, 152.3669327, 152.3827387, 152.3978755, 152.412379,
              152.4262827, 152.4396177, 152.4524128, 152.464695, 152.4764895,
              152.4878198, 152.498708, 152.5091747, 152.5192393, 152.52892,
              152.5382338, 152.5471971, 152.5558248, 152.5641315, 152.5721307,
              152.5798353, 152.5872574, 152.5944085, 152.6012996, 152.6079412,
              152.6143431, 152.6205147, 152.626465, 152.6322026, 152.6377356,
              152.6430718, 152.6482187, 152.6507234,
            ],

            endLabel: {
              show: true,
              formatter: "5th",
            },
            smooth: true,
            lineStyle: {
              color: "#999090",
            },
            showSymbol: false,
          },
          {
            name: "10th Percentile ",
            type: "line",
            data: [
              80.52476467, 80.91946302, 81.73540957, 82.5369944, 83.31968453,
              84.07997909, 84.81531679, 85.52398013, 86.20500071, 86.85806752,
              87.48343922, 88.08186325, 88.6544988, 89.20284893, 89.74875322,
              90.28810699, 90.82227549, 91.35246174, 91.87972051, 92.40497144,
              92.92901112, 93.45252422, 93.97609374, 94.50021028, 95.02528063,
              95.55163545, 96.07953634, 96.60918226, 97.14071535, 97.67422621,
              98.20975881, 98.74731484, 99.28685775, 99.82831652, 100.371589,
              100.9165451, 101.4630296, 102.0108651, 102.5598541, 103.1097819,
              103.6604184, 104.2115203, 104.762833, 105.3140925, 105.8650274,
              106.4153599, 106.9648081, 107.5130874, 108.0599112, 108.6049935,
              109.148049, 109.6887954, 110.2269537, 110.7622502, 111.2944168,
              111.8231928, 112.3483251, 112.8695701, 113.3866939, 113.8994733,
              114.407697, 114.9111662, 115.4096953, 115.9031127, 116.391262,
              116.874002, 117.351208, 117.8227724, 118.2886054, 118.7486357,
              119.2028114, 119.651101, 120.0934937, 120.5300007, 120.9606563,
              121.3855185, 121.8046703, 122.2182208, 122.6263066, 123.029093,
              123.4267753, 123.8195805, 124.2077692, 124.5916364, 124.9715143,
              125.3477734, 125.7208245, 126.0911208, 126.4591593, 126.8254825,
              127.1906801, 127.5553896, 127.9202978, 128.2861404, 128.6537014,
              129.0238124, 129.3973496, 129.7752299, 130.1584061, 130.5478595,
              130.9445907, 131.3496084, 131.7639151, 132.1884911, 132.6242751,
              133.072142, 133.5328789, 134.0071586, 134.4955119, 134.9982982,
              135.5156778, 136.0475846, 136.5937022, 137.1534445, 137.7259419,
              138.3100351, 138.9042785, 139.5069517, 140.1160824, 140.7294775,
              141.3447662, 141.9594471, 142.5709442, 143.1766639, 143.7740547,
              144.3606631, 144.9341866, 145.4925187, 146.0337866, 146.5563788,
              147.0589626, 147.5404925, 148.0002085, 148.437627, 148.8525242,
              149.2449147, 149.6150259, 149.9632704, 150.2902174, 150.5965645,
              150.8831097, 151.1507267, 151.4003414, 151.6329115, 151.8494087,
              152.0508033, 152.238053, 152.4120911, 152.5738202, 152.7241057,
              152.8637721, 152.9936001, 153.1143251, 153.2266371, 153.3311804,
              153.4285552, 153.5193185, 153.6039864, 153.6830356, 153.7569057,
              153.8260015, 153.8906954, 153.951329, 154.0082162, 154.0616446,
              154.1118775, 154.1591564, 154.2037023, 154.2457175, 154.2853872,
              154.3228809, 154.3583538, 154.3919483, 154.4237944, 154.4540118,
              154.4827098, 154.509989, 154.5359417, 154.5606528, 154.5842002,
              154.6066558, 154.6280858, 154.6485512, 154.6681084, 154.6868095,
              154.7047027, 154.7218327, 154.7382408, 154.7539655, 154.7690427,
              154.7835054, 154.7973849, 154.81071, 154.8235077, 154.8358035,
              154.8476208, 154.8589821, 154.8699082, 154.8804186, 154.8905318,
              154.9002654, 154.9096356, 154.9186579, 154.9273472, 154.9357171,
              154.9437809, 154.9515511, 154.9590395, 154.9662574, 154.9732154,
              154.9799237, 154.9863922, 154.9926299, 154.9986458, 155.0044483,
              155.0100454, 155.0154449, 155.0180729,
            ],
            endLabel: {
              show: true,
              formatter: "10th",
            },
            smooth: true,
            lineStyle: {
              color: "#716868",
            },
            showSymbol: false,
          },
          {
            name: "25th Percentile ",
            type: "line",
            data: [
              82.63523563, 83.04213246, 83.89430336, 84.72592034, 85.53389245,
              86.31588888, 87.07028387, 87.7960919, 88.49290603, 89.16083624,
              89.80044644, 90.41270297, 90.99890839, 91.56065781, 92.12298263,
              92.67925322, 93.23069622, 93.77840211, 94.3233355, 94.86634477,
              95.40817129, 95.94945793, 96.49075704, 97.03253788, 97.57519341,
              98.11904662, 98.66435637, 99.2113227, 99.76009185, 100.3107608,
              100.8633813, 101.4179641, 101.9744822, 102.5328747, 103.0930492,
              103.6548853, 104.2182371, 104.7829358, 105.348792, 105.9155982,
              106.4831306, 107.0511517, 107.6194116, 108.1876502, 108.7555991,
              109.3229831, 109.8895213, 110.4549317, 111.0189247, 111.5812164,
              112.1415202, 112.6995522, 113.2550319, 113.8076835, 114.3572371,
              114.9034294, 115.4460056, 115.9847196, 116.5193358, 117.0496296,
              117.5753884, 118.0964128, 118.6125173, 119.1235313, 119.6293,
              120.1296849, 120.6245654, 121.113839, 121.5974226, 122.0752529,
              122.5472882, 123.0135084, 123.4739166, 123.92854, 124.3774309,
              124.8206679, 125.2583572, 125.6906338, 126.1176628, 126.5396411,
              126.9567984, 127.3693994, 127.7777448, 128.1821733, 128.5830629,
              128.9808329, 129.3759451, 129.7689053, 130.1602643, 130.5506193,
              130.9406135, 131.330937, 131.7223254, 132.1155587, 132.5114586,
              132.9108849, 133.3147302, 133.7239135, 134.1393714, 134.5620476,
              134.9928804, 135.4327874, 135.8826474, 136.3432832, 136.8154369,
              137.299748, 137.7967284, 138.3067365, 138.8299523, 139.3663536,
              139.9156938, 140.4774848, 141.0509836, 141.6351863, 142.228829,
              142.8303943, 143.4381342, 144.0500909, 144.6641345, 145.2779986,
              145.8893375, 146.4957662, 147.0949169, 147.6844892, 148.2622979,
              148.8263158, 149.3747099, 149.9058698, 150.4184277, 150.9112703,
              151.3835413, 151.8346381, 152.2642007, 152.6720956, 153.0583966,
              153.4233611, 153.7674066, 154.0910856, 154.3950608, 154.6800825,
              154.9469659, 155.1965718, 155.4297888, 155.6475179, 155.8506598,
              156.0401024, 156.2167175, 156.3813442, 156.5347914, 156.6778321,
              156.8112003, 156.9355896, 157.0516529, 157.1600033, 157.2612106,
              157.3558081, 157.4442908, 157.5271178, 157.6047139, 157.6774719,
              157.7457539, 157.809894, 157.8701998, 157.9269542, 157.9804176,
              158.0308292, 158.0784088, 158.1233583, 158.1658633, 158.2060942,
              158.2442076, 158.2803474, 158.3146459, 158.3472249, 158.3781962,
              158.407663, 158.4357202, 158.4624554, 158.4879492, 158.5122763,
              158.5355056, 158.5577008, 158.578921, 158.5992207, 158.6186507,
              158.6372582, 158.6550869, 158.6721776, 158.6885682, 158.7042942,
              158.7193886, 158.7338824, 158.7478045, 158.7611821, 158.7740404,
              158.7864036, 158.798294, 158.8097328, 158.8207399, 158.8313341,
              158.8415332, 158.851354, 158.8608124, 158.8699234, 158.8787012,
              158.8871595, 158.8953111, 158.9031682, 158.9107425, 158.918045,
              158.9250863, 158.9318765, 158.9384252, 158.9447416, 158.9508345,
              158.9567122, 158.9623829, 158.9651429,
            ],

            endLabel: {
              show: true,
              formatter: "25th",
            },
            smooth: true,
            lineStyle: {
              color: "#5d5555",
            },
            showSymbol: false,
          },
          {
            name: "50th Percentile ",
            type: "line",
            data: [
              84.97555512, 85.3973169, 86.29026318, 87.15714182, 87.9960184,
              88.8055115, 89.58476689, 90.33341722, 91.0515436, 91.7396352,
              92.39854429, 93.02945392, 93.63382278, 94.21335709, 94.79643239,
              95.37391918, 95.94692677, 96.51644912, 97.08337211, 97.6484807,
              98.21246579, 98.77593069, 99.33939735, 99.9033122, 100.4680516,
              101.033927, 101.6011898, 102.1700358, 102.7406094, 103.3130077,
              103.8872839, 104.4634511, 105.0414853, 105.6213287, 106.2028921,
              106.7860583, 107.3706841, 107.9566031, 108.5436278, 109.1315521,
              109.7201531, 110.3091934, 110.8984228, 111.4875806, 112.0763967,
              112.6645943, 113.2518902, 113.8380006, 114.4226317, 115.0054978,
              115.5863089, 116.1647782, 116.7406221, 117.3135622, 117.8833259,
              118.4496481, 119.0122722, 119.5709513, 120.1254495, 120.6755427,
              121.22102, 121.7616844, 122.2973542, 122.827864, 123.3530652,
              123.8728276, 124.38704, 124.8956114, 125.398472, 125.895574,
              126.3868929, 126.8724284, 127.3522056, 127.8262759, 128.2947187,
              128.757642, 129.2151839, 129.6675143, 130.1148354, 130.5573839,
              130.995432, 131.4292887, 131.8593015, 132.2858574, 132.7093845,
              133.1303527, 133.5492749, 133.9667073, 134.3832499, 134.7995463,
              135.2162826, 135.634186, 136.0540223, 136.4765925, 136.9027281,
              137.3332846, 137.7691339, 138.2111552, 138.6602228, 139.1171933,
              139.5828898, 140.0580848, 140.5434787, 141.0396832, 141.5471945,
              142.0663731, 142.59742, 143.1403553, 143.6949981, 144.2609497,
              144.8375809, 145.4240246, 146.0191748, 146.621692, 147.2300177,
              147.8423918, 148.4568879, 149.0714413, 149.6838943, 150.2920328,
              150.8936469, 151.4865636, 152.0686985, 152.6380955, 153.1929631,
              153.7317031, 154.2529332, 154.755501, 155.2384904, 155.7012216,
              156.1432438, 156.564323, 156.9644258, 157.3436995, 157.7024507,
              158.0411233, 158.3602756, 158.6605588, 158.9426964, 159.2074654,
              159.455679, 159.688172, 159.9057871, 160.1093647, 160.299733,
              160.4776996, 160.6440526, 160.7995428, 160.9448916, 161.0807857,
              161.2078755, 161.3267744, 161.4380593, 161.5422726, 161.639917,
              161.7314645, 161.8173534, 161.8979913, 161.9737558, 162.0449969,
              162.1120386, 162.17518, 162.2346979, 162.2908474, 162.343864,
              162.3939652, 162.4413513, 162.4862071, 162.5287029, 162.5689958,
              162.6072309, 162.6435418, 162.6780519, 162.7108751, 162.7421168,
              162.7718741, 162.8002371, 162.8272889, 162.8531067, 162.8777619,
              162.9013208, 162.9238449, 162.9453912, 162.9660131, 162.9857599,
              163.0046776, 163.0228094, 163.0401953, 163.0568727, 163.0728768,
              163.0882404, 163.1029943, 163.1171673, 163.1307866, 163.1438776,
              163.1564644, 163.1685697, 163.1802146, 163.1914194, 163.202203,
              163.2125835, 163.2225779, 163.2322024, 163.2414722, 163.2504019,
              163.2590052, 163.2672954, 163.2752848, 163.2829854, 163.2904086,
              163.297565, 163.304465, 163.3111185, 163.3175349, 163.3237231,
              163.3296918, 163.3354491, 163.338251,
            ],

            endLabel: {
              show: true,
              formatter: "50th",
            },
            smooth: true,
            lineStyle: {
              color: "#000000",
            },
            showSymbol: false,
          },
          {
            name: "75th Percentile ",
            type: "line",
            data: [
              87.31121356, 87.74917522, 88.683435, 89.5875095, 90.46017565,
              91.30065173, 92.10858598, 92.88403041, 93.62741325, 94.33950841,
              95.02140026, 95.67445723, 96.30028751, 96.9007148, 97.50723533,
              98.10854769, 98.70568284, 99.2995686, 99.89103539, 100.4808219,
              101.0695807, 101.6578832, 102.2462253, 102.8350319, 103.4246616,
              104.0154114, 104.6075204, 105.2011743, 105.7965086, 106.3936129,
              106.9925336, 107.5932772, 108.1958137, 108.8000793, 109.405979,
              110.0133894, 110.6221611, 111.2321213, 111.8430758, 112.4548114,
              113.0670984, 113.6796918, 114.2923342, 114.9047572, 115.5166834,
              116.1278283, 116.7379017, 117.3466121, 117.9536599, 118.5587525,
              119.1615941, 119.7618926, 120.3593603, 120.9537147, 121.5446807,
              122.1319914, 122.7153896, 123.2946291, 123.8694758, 124.4397092,
              125.0051231, 125.5655273, 126.1207484, 126.6706308, 127.2150383,
              127.7538545, 128.2869845, 128.8143555, 129.3359181, 129.8516474,
              130.3615441, 130.8656354, 131.3639763, 131.8566506, 132.3437724,
              132.8254867, 133.3019713, 133.7734371, 134.2401302, 134.7023324,
              135.1603626, 135.6145777, 136.0653737, 136.5131864, 136.9584917,
              137.4018066, 137.8436884, 138.2847346, 138.7255822, 139.1669053,
              139.6094137, 140.0538485, 140.5009788, 140.9515953, 141.406504,
              141.8665172, 142.3324443, 142.8050794, 143.2851879, 143.7734919,
              144.2706527, 144.7772534, 145.2937779, 145.8205935, 146.3579283,
              146.9058529, 147.4642617, 148.0328573, 148.6111378, 149.1983881,
              149.7936767, 150.3958583, 151.0035823, 151.6153083, 152.2293288,
              152.8437944, 153.4567526, 154.0661803, 154.6700274, 155.2662534,
              155.8528786, 156.4280126, 156.9898953, 157.5369262, 158.0676887,
              158.5809683, 159.0757636, 159.5512908, 160.006982, 160.4424774,
              160.8576139, 161.252409, 161.6270427, 161.9818377, 162.317239,
              162.633793, 162.9321282, 163.2129368, 163.476957, 163.7249588,
              163.9577297, 164.1760637, 164.3807514, 164.572572, 164.7522868,
              164.920633, 165.0783248, 165.2260411, 165.3644316, 165.4941133,
              165.6156697, 165.7296508, 165.8365737, 165.9369248, 166.0311556,
              166.1196904, 166.202924, 166.281224, 166.3549321, 166.4243655,
              166.4898188, 166.5515647, 166.6098562, 166.6649274, 166.7169951,
              166.7662599, 166.8129074, 166.8571093, 166.8990246, 166.9388003,
              166.9765723, 167.0124668, 167.0466004, 167.0790811, 167.110009,
              167.1394771, 167.1675715, 167.1943721, 167.2199532, 167.244384,
              167.2677286, 167.2900467, 167.3113942, 167.3318229, 167.3513812,
              167.3701145, 167.388065, 167.4052723, 167.4217734, 167.437603,
              167.4527938, 167.4673763, 167.4813792, 167.4948296, 167.5077529,
              167.520173, 167.5321128, 167.5435933, 167.554635, 167.5652567,
              167.5754766, 167.5853118, 167.5947785, 167.6038921, 167.6126671,
              167.6211174, 167.6292563, 167.6370963, 167.6446494, 167.6519269,
              167.6589397, 167.6656981, 167.6722121, 167.678491, 167.684544,
              167.6903797, 167.6960062, 167.6987436,
            ],
            endLabel: {
              show: true,
              formatter: "75th",
            },
            smooth: true,
            lineStyle: {
              color: "#5d5555",
            },
            showSymbol: false,
          },
          {
            name: "90th Percentile ",
            type: "line",
            data: [
              89.40951159, 89.86315834, 90.83504785, 91.77420584, 92.67968776,
              93.55096822, 94.38792816, 95.19083262, 95.96030359, 96.69728978,
              97.40303421, 98.07904266, 98.72704954, 99.34898744, 99.97896123,
              100.6040005, 101.2250993, 101.8431523, 102.4589604, 103.0732359,
              103.6866076, 104.2996257, 104.9127666, 105.5264371, 106.1409795,
              106.7566748, 107.3737475, 107.9923687, 108.6126601, 109.2346972,
              109.8585126, 110.4840992, 111.1114131, 111.7403765, 112.3708801,
              113.0027865, 113.6359317, 114.2701285, 114.9051683, 115.5408235,
              116.1768496, 116.8129879, 117.4489667, 118.0845041, 118.7193096,
              119.3530862, 119.9855318, 120.6163423, 121.2452109, 121.8718331,
              122.4959057, 123.1171295, 123.7352109, 124.3498634, 124.9608087,
              125.5677788, 126.1705167, 126.7687784, 127.3623338, 127.9509681,
              128.5344832, 129.1126986, 129.6854529, 130.2526047, 130.8140342,
              131.3696436, 131.9193587, 132.4631302, 133.000934, 133.5327731,
              134.0586782, 134.5787089, 135.0929548, 135.6015364, 136.1046066,
              136.602351, 137.0949894, 137.5827768, 138.0660041, 138.5449986,
              139.0201256, 139.4917879, 139.9604267, 140.4265216, 140.8905903,
              141.3531879, 141.8149059, 142.2763706, 142.7382405, 143.2012034,
              143.6659721, 144.1332799, 144.6038739, 145.0785079, 145.5579335,
              146.0428902, 146.5340936, 147.0322225, 147.5379045, 148.0517004,
              148.5740881, 149.1054445, 149.6460289, 150.1959657, 150.7552278,
              151.3236226, 151.9007796, 152.4861414, 153.0789588, 153.6782905,
              154.2830074, 154.8918033, 155.5032105, 156.1156207, 156.7273114,
              157.336476, 157.9412574, 158.5397832, 159.1302018, 159.710717,
              160.2796226, 160.8353311, 161.3763995, 161.9015501, 162.4096857,
              162.8998985, 163.3714746, 163.8238923, 164.2568163, 164.6700879,
              165.0637118, 165.4378408, 165.7927589, 166.1288638, 166.4466488,
              166.7466859, 167.0296087, 167.2960978, 167.5468664, 167.7826481,
              168.0041861, 168.2122241, 168.4074983, 168.5907313, 168.7626268,
              168.9238654, 169.0751026, 169.2169651, 169.3500504, 169.4749261,
              169.5921291, 169.7021662, 169.8055142, 169.9026209, 169.9939056,
              170.0797608, 170.160553, 170.236624, 170.3082921, 170.3758539,
              170.4395847, 170.4997408, 170.5565599, 170.6102627, 170.6610542,
              170.7091243, 170.7546494, 170.7977929, 170.8387064, 170.8775306,
              170.914396, 170.9494236, 170.9827258, 171.014407, 171.0445641,
              171.0732871, 171.1006598, 171.1267599, 171.1516601, 171.1754277,
              171.1981258, 171.2198128, 171.2405436, 171.2603693, 171.2793375,
              171.2974929, 171.3148774, 171.33153, 171.3474874, 171.362784,
              171.3774521, 171.3915221, 171.4050225, 171.4179802, 171.4304205,
              171.4423671, 171.4538427, 171.4648684, 171.4754644, 171.4856495,
              171.4954418, 171.5048583, 171.5139151, 171.5226274, 171.5310098,
              171.5390761, 171.5468394, 171.5543121, 171.561506, 171.5684326,
              171.5751024, 171.5815258, 171.5877126, 171.5936721, 171.5994132,
              171.6049444, 171.6102738, 171.6128653,
            ],
            endLabel: {
              show: true,
              formatter: "90th",
            },
            smooth: true,
            lineStyle: {
              color: "#716868",
            },
            showSymbol: false,
          },
          {
            name: "95th Percentile ",
            type: "line",
            data: [
              90.66354871, 91.12706971, 92.12167631, 93.08254082, 94.00872819,
              94.89974364, 95.75551171, 96.57635253, 97.36295103, 98.11632342,
              98.83778417, 99.52890698, 100.191497, 100.8275527, 101.4726459,
              102.112939, 102.7494191, 103.3829734, 104.0143944, 104.6443859,
              105.2735676, 105.9024803, 106.5315907, 107.161296, 107.7919282,
              108.4237579, 109.0569988, 109.6918111, 110.3283052, 110.9665451,
              111.6065515, 112.2483051, 112.8917498, 113.536795, 114.1833188,
              114.8311708, 115.4801741, 116.1301284, 116.780812, 117.4319846,
              118.0833889, 118.7347537, 119.3857953, 120.03622, 120.685726,
              121.3340057, 121.9807474, 122.6256361, 123.2683596, 123.9086035,
              124.5460585, 125.1804203, 125.8113907, 126.4386798, 127.0620077,
              127.6811055, 128.2957169, 128.9056, 129.5105281, 130.1102914,
              130.7046982, 131.2935761, 131.876773, 132.4541587, 133.025626,
              133.5910912, 134.150496, 134.7038082, 135.2510227, 135.7921628,
              136.3272809, 136.8564598, 137.3798137, 137.8974887, 138.4096645,
              138.9165546, 139.4184075, 139.9155075, 140.4081749, 140.8967672,
              141.3816789, 141.8633417, 142.3422248, 142.818834, 143.2937108,
              143.7674316, 144.2406053, 144.7138712, 145.1878952, 145.6633664,
              146.1409913, 146.6214882, 147.1055797, 147.5939843, 148.0874065,
              148.586526, 149.0919854, 149.6043767, 150.1242269, 150.6519828,
              151.1879951, 151.7325029, 152.2856189, 152.8473131, 153.4174019,
              153.9955367, 154.581196, 155.1736815, 155.7721177, 156.3754566,
              156.9824866, 157.591847, 158.2020466, 158.8114866, 159.4184879,
              160.0213216, 160.6182378, 161.2075007, 161.7874182, 162.3563754,
              162.9128551, 163.4554684, 163.9829705, 164.4942764, 164.9884705,
              165.4648118, 165.9227345, 166.3618445, 166.7819123, 167.1828627,
              167.5647631, 167.9278093, 168.2723104, 168.5986736, 168.9073892,
              169.1990151, 169.474163, 169.7334849, 169.9776618, 170.207392,
              170.4233822, 170.6263392, 170.8169629, 170.9959407, 171.1639423,
              171.3216174, 171.469589, 171.6084579, 171.7387957, 171.8611461,
              171.9760242, 172.0839168, 172.1852824, 172.2805514, 172.3701297,
              172.4543957, 172.5337038, 172.6083849, 172.6787478, 172.7450799,
              172.8076491, 172.8667045, 172.9224777, 172.9751838, 173.025023,
              173.0721808, 173.1168298, 173.1591301, 173.1992303, 173.2372685,
              173.2733728, 173.3076624, 173.3402478, 173.3712319, 173.4007102,
              173.4287717, 173.455499, 173.4809691, 173.5052538, 173.5284198,
              173.5505296, 173.5716411, 173.5918087, 173.6110831, 173.6295117,
              173.6471389, 173.6640061, 173.6801522, 173.6956138, 173.710425,
              173.7246179, 173.7382228, 173.751268, 173.7637802, 173.7757847,
              173.787305, 173.7983636, 173.8089816, 173.8191789, 173.8289744,
              173.8383858, 173.8474302, 173.8561235, 173.8644808, 173.8725166,
              173.8802445, 173.8876774, 173.8948277, 173.9017071, 173.9083268,
              173.9146973, 173.9208289, 173.9267311, 173.9324132, 173.9378839,
              173.9431517, 173.9482244, 173.9506901,
            ],
            endLabel: {
              show: true,
              formatter: "95th",
            },
            smooth: true,
            lineStyle: {
              color: "#999090",
            },
            showSymbol: false,
          },
          {
            name: "97th Percentile ",
            type: "line",
            data: [
              91.47728689, 91.94741225, 92.95684975, 93.9320912, 94.87214661,
              95.77649339, 96.64504712, 97.47813528, 98.27646264, 99.04107435,
              99.77332166, 100.4748164, 101.1474075, 101.7931359, 102.448488,
              103.0991159, 103.7460086, 104.3900531, 105.0320405, 105.6726719,
              106.3125633, 106.9522508, 107.5921959, 108.2327896, 108.8743573,
              109.5171624, 110.1614111, 110.8072554, 111.4547971, 112.1040915,
              112.7551501, 113.4079442, 114.0624076, 114.7184401, 115.3759096,
              116.0346553, 116.6944901, 117.3552032, 118.0165629, 118.6783183,
              119.3402023, 120.0019338, 120.6632194, 121.3237564, 121.9832342,
              122.6413368, 123.297745, 123.9521353, 124.6041916, 125.2535916,
              125.9000218, 126.5431735, 127.1827453, 127.8184451, 128.4499914,
              129.0771148, 129.69956, 130.3170863, 130.9294701, 131.5365053,
              132.1380052, 132.7338033, 133.323755, 133.9077383, 134.4856552,
              135.0574328, 135.6230245, 136.1824107, 136.7356, 137.2826306,
              137.8235707, 138.3585197, 138.8876092, 139.411004, 139.9289024,
              140.4415378, 140.9491785, 141.4521292, 141.9507308, 142.4453609,
              142.936434, 143.4244013, 143.9097502, 144.3930034, 144.8747179,
              145.3554829, 145.8359173, 146.3166671, 146.798401, 147.2818057,
              147.7675803, 148.2564292, 148.7490543, 149.2461456, 149.7483713,
              150.2563656, 150.7707169, 151.2919534, 151.8205297, 152.3568114,
              152.9010603, 153.4534201, 154.0139039, 154.5823786, 155.1585578,
              155.741993, 156.3320686, 156.9280012, 157.5288429, 158.1334886,
              158.740688, 159.3490618, 159.9571223, 160.5632969, 161.1659545,
              161.7634371, 162.3540831, 162.9362629, 163.5084028, 164.0690181,
              164.6167234, 165.1502647, 165.6685285, 166.1705539, 166.6555396,
              167.1228459, 167.5719943, 168.0026622, 168.4146759, 168.8080012,
              169.1827317, 169.5390766, 169.8773471, 170.1979436, 170.5013414,
              170.7880784, 171.0587419, 171.3139575, 171.5543778, 171.780673,
              171.9935219, 172.1936047, 172.3815959, 172.5581591, 172.7239426,
              172.8795764, 173.0256638, 173.1627906, 173.2915138, 173.4123635,
              173.5258431, 173.6324287, 173.7325694, 173.8266863, 173.9151788,
              173.9984185, 174.0767538, 174.1505102, 174.2199918, 174.2854819,
              174.3472447, 174.405526, 174.4605545, 174.5125428, 174.5616886,
              174.6081757, 174.6521747, 174.6938442, 174.7333314, 174.7707732,
              174.8062967, 174.8400201, 174.8720532, 174.902498, 174.9314494,
              174.9589959, 174.9852197, 175.0101973, 175.034, 175.0566944,
              175.0783424, 175.099002, 175.1187272, 175.1375685, 175.155573,
              175.1727851, 175.1892459, 175.2049944, 175.2200667, 175.2344971,
              175.2483174, 175.2615577, 175.2742464, 175.2864101, 175.2980736,
              175.3092608, 175.3199938, 175.3302936, 175.3401801, 175.349672,
              175.358787, 175.367542, 175.3759527, 175.3840343, 175.391801,
              175.3992664, 175.4064433, 175.4133439, 175.4199799, 175.4263623,
              175.4325015, 175.4384076, 175.4440902, 175.4495583, 175.4548206,
              175.4598853, 175.4647604, 175.4671292,
            ],
            endLabel: {
              show: true,
              formatter: "97th",
            },
            smooth: true,
            lineStyle: {
              color: "#b9b0b0",
            },
            showSymbol: false,
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.chart {
  height: 850px;
}
</style>
